import { configureStore, createListenerMiddleware, useSelector } from "@reduxjs/toolkit";
import translationReducer, {leftColFilledOutUpdated, rightColFilledOutUpdated } from "./slices/translationSlice";
import interpretationReducer, {leftColFilledOutUpdated_int, rightColFilledOutUpdated_int } from "./slices/interpretationSlice"; // MAKE SURE TO PUT BACK IN
import assessmentReducer, {page1ProgressBarUpdated, page2ProgressBarUpdated, page3ProgressBarUpdated} from "./slices/assessmentSlice";

const listenerMiddleware = createListenerMiddleware();

const store = configureStore({
  reducer: {
    translation: translationReducer,
    interpretation: interpretationReducer,
    assessment: assessmentReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(listenerMiddleware.middleware),
});

listenerMiddleware.startListening({
  predicate: (_action, currentState, previousState) => {
    return currentState !== previousState;
  },
  effect: async (action, listenerApi) => {
    let actionType = action.type;
    actionType = actionType.substring(0, actionType.indexOf("/"));
    if(actionType === "translation") {
        listenerApi.dispatch(leftColFilledOutUpdated(action.payload));
        listenerApi.dispatch(rightColFilledOutUpdated(action.payload));
    }
    else if(actionType === "interpretation") {
        listenerApi.dispatch(leftColFilledOutUpdated_int(action.payload));
        listenerApi.dispatch(rightColFilledOutUpdated_int(action.payload));
    }
    else if(actionType === "assessment") {
        //alert("assessment action detected");
        listenerApi.dispatch(page1ProgressBarUpdated(action.payload));
        listenerApi.dispatch(page2ProgressBarUpdated(action.payload));
        listenerApi.dispatch(page3ProgressBarUpdated(action.payload));
    }    
  },
});

export default store;
